<template>
  <div>
    <Banner
      :titulo="banner.title"
      :image="banner.image"
      :respimage="banner.resp_image"
    />
    <div v-for="(block, key) in this.blocks">
      <Block1
        :title="blocks[key].title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 1"
      />

      <Block2
        :title="blocks[key].title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 2"
      />

      <Block3
        :title="blocks[key].title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 3"
      />

      <Block4
        :title="blocks[key].title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 4"
      />

      <Block5
        :title="blocks[key].title"
        :figure="blocks[key].bg_image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        :bg_resp_color="blocks[key].bg_resp_color"
        v-if="blocks[key].block_type === 5"
      />

      <Block6
        :title="blocks[key].title"
        :figure="blocks[key].bg_image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        :bg_resp_color="blocks[key].bg_resp_color"
        v-if="blocks[key].block_type === 6"
      />

      <Block7
        :title="blocks[key].title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 7"
      />

      <Block8
        :title="blocks[key].title"
        :figure="blocks[key].image"
        :content="blocks[key].content"
        :bg_color="blocks[key].bg_color"
        :resp_image="blocks[key].resp_image"
        v-if="blocks[key].block_type === 8"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";
import Banner from "../shared/Banner";
import Block1 from "../shared/blocks/Block1";
import Block2 from "../shared/blocks/Block2";
import Block3 from "../shared/blocks/Block3";
import Block4 from "../shared/blocks/Block4";
import Block5 from "../shared/blocks/Block5";
import Block6 from "../shared/blocks/Block6";
import Block7 from "../shared/blocks/Block7";
import CasesService from "../../domain/CasesService";
import BannerService from "../../domain/bannerService";

export default {
  components: {
    Banner,
    Block1,
    Block2,
    Block3,
    Block4,
    Block5,
    Block6,
    Block7
  },
  watch: {
    "$i18n.locale": function() {
      this.init();
    }
  },
  data() {
    return {
      titulo: "Cases",
      content: null,
      figure: null,
      blocks: [],
      banner: []
    };
  },
  methods: {
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;
      this.serviceCases.blocks().then(res => {
        this.blocks = res;
        return this.block;
      });
      this.bannerService.blocks().then(res => {
        this.banner = res;
        this.banner = this.banner[0];
        return this.banner;
      });
    }
  },
  created() {
    this.serviceCases = new CasesService(this.$resource);
    this.bannerService = new BannerService(this.$resource, "CASES");
    this.init();
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/cases/Cases.vue